import { Component, OnInit, ViewChild } from '@angular/core';
import { OrderPipe } from 'ngx-order-pipe';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
      providers: [OrderPipe] // Add this line
})
export class FooterComponent implements OnInit {
  constructor() {
  }
  ngOnInit() { }
}
